<template>

  <v-container>
    <v-btn color="cyan" class="white--text" @click="addAnswers">
      <v-icon color="white">add</v-icon> 追加
    </v-btn>
    <v-dialog v-if="showDialog" v-model="selectedAnswer" :fullscreen="true">
      <v-container grid-list-md>
        <v-card>
          <v-card-text>
            <v-layout row wrap>
              <v-radio-group v-model="selectedAnswer.type" :mandatory="true" row>
                <div slot="label">サーベイタイプ</div>
                <v-radio label="本人" value="subject"></v-radio>
                <v-radio label="協力者" value="coWorker"></v-radio>
              </v-radio-group>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs10 md5>
                <v-select v-model="subject" :items="usersArray" item-text="name" item-value="id" label="対象者" return-object></v-select>
              </v-flex>
              <v-flex xs10 md5 v-show="selectedAnswer.type=='coWorker'">
                <v-select v-model="user" :items="usersArray" item-text="name" item-value="id" label="協力者" return-object></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="createAnswers">追加</v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn @click="showDialog=false">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-dialog>
    <v-data-table :items="emails" :headers="headers" class="elevation-1" :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination" rows-per-page-text="表示行">
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{props.item.subject}}</td>
          <td>{{props.item.to}}</td>
          <td> {{props.item.datetime}}</td>
          <td>{{props.item.status}}</td>
        </tr>
      </template>
      <template slot="pageText" slot-scope="props">
        {{ props.itemsLength }} 件中 {{ props.pageStart }} - {{ props.pageStop }} 件表示
      </template>
    </v-data-table>
  </v-container>

</template>
<script>
import db from '@/components/firebaseInit'
export default {
  components: {},
  props: {
    //answerItems: {}
  },
  data() {
    return {
      emails: [{subject:"",to:"",datetime:"",status:"",body:""}],
      headers: [
        { text: '件名', value: 'subject', sortable: true },
        { text: '送信先', value: 'to', sortable: true },
        { text: '送信日時', value: 'datetime', sortable: true },
        { text: 'ステータス', value: 'status', sortable: true },
      ],
      userDbRef: db.collection("companies").doc(this.$route.params.company_id).collection("users"),
      answerDbRef: db.collection("companies").doc(this.$route.params.company_id).collection("surveys").doc(this.$route.params.survey_id).collection("answer_sheets"),
      showDialog: false,
      newAnsewer: { email: "", name: "", result: {}, status: "未実施", subject_id: "", subject_name: "", type: "coWorker", user_id: "" },
      selectedAnswer: {},
      users: {},
      usersArray: [],
      subject: {},
      user: {},
      rowsPerPageItems: [25, 50, 100],
      pagination: {
        rowsPerPage: 25
      },
    }
  },
  mounted() {
    // this.getUsers()

  },
  watch: {
    // subject() {
    //   this.selectedAnswer.subject_id = this.subject.id
    //   this.selectedAnswer.subject_name = this.subject.name
    //   if (this.selectedAnswer.subject_id.type == 'subject') {
    //     this.selectedAnswer.user_id = this.subject.id
    //     this.selectedAnswer.name = this.subject.name
    //     this.selectedAnswer.email = this.subject.email
    //   }
    // },
    // user() {
    //   this.selectedAnswer.user_id = this.user.id
    //   this.selectedAnswer.name = this.user.name
    //   this.selectedAnswer.email = this.user.email
    // },


  },
  methods: {
    editAnswers() {
      // 実施済み回答の編集等複雑な仕様が発生するので一旦実装しない
    },
    async deleteAnswers(ans) {
      await this.answerDbRef.doc(ans.id).delete().catch(e => {
        console.error("Error removing document: ", e);
      })
    },
    addAnswers() {
      this.selectedAnswer = JSON.parse(JSON.stringify(this.newAnsewer))
      this.showDialog = true
    },
    createAnswers() {
      this.selectedAnswer.subject_id = this.subject.id
      this.selectedAnswer.subject_name = this.subject.name
      if (this.selectedAnswer.type == 'subject') {
        this.selectedAnswer.user_id = this.subject.id
        this.selectedAnswer.name = this.subject.name
        this.selectedAnswer.email = this.subject.email
      }
      else {
        this.selectedAnswer.user_id = this.user.id
        this.selectedAnswer.name = this.user.name
        this.selectedAnswer.email = this.user.email
      }
      this.answerDbRef.add(this.selectedAnswer)
      this.showDialog = false
    },
    async getUsers() {
      this.users = {}
      this.usersArray = []
      const querySnapshot = await this.userDbRef.get()
      querySnapshot.forEach(doc => {
        const user = doc.data()
        this.users[doc.id] = { ...user, id: doc.id }
        this.usersArray.push({ ...user, id: doc.id })
      })

    },
    getSurveyType(type) {
      return type == "subject" ? "本人" : "協力者"
    }
  },
}
</script>